module.exports = __webpack_public_path__ + "static/m_1-5397979ef1447db5ef9ad3627e1beeac.png";